import { Link } from 'react-router-dom';
import { useTheme } from '@/context/ThemeContext';
import { useAuth } from '@/context/AuthContext';
import { Compass, ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
  const { colors: T } = useTheme();
  const { user } = useAuth();
  const home = user ? '/dashboard/all-brands/command-center' : '/';

  return (
    <main id="main" style={{ minHeight: '100vh', background: T.bg, display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div data-testid="not-found" style={{ maxWidth: 520, textAlign: 'center' }}>
        <div style={{ width: 56, height: 56, borderRadius: 14, margin: '0 auto 22px',
          display: 'grid', placeItems: 'center', background: 'rgba(0,47,167,.08)',
          border: '1px solid rgba(0,47,167,.2)', color: '#002FA7' }}>
          <Compass size={26} />
        </div>
        <h1 style={{ fontSize: 'clamp(28px,5vw,40px)', fontWeight: 800, color: T.cardText,
          letterSpacing: '-.03em', margin: '0 0 12px' }}>
          That page doesn't exist
        </h1>
        <p style={{ fontSize: 15, color: T.muted, lineHeight: 1.6, margin: '0 0 28px' }}>
          The link may be out of date, or the dashboard view it pointed to has been renamed.
          Every dashboard now lives at a URL like <code style={{ fontFamily: 'IBM Plex Mono, monospace',
          fontSize: 13, padding: '2px 6px', borderRadius: 4, background: T.surfaceAlpha,
          border: `1px solid ${T.border}` }}>/dashboard/luminoskin/paid-media</code>.
        </p>
        <Link to={home} data-testid="not-found-home"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '12px 22px',
            borderRadius: 999, background: '#002FA7', color: '#fff', fontSize: 14, fontWeight: 600,
            textDecoration: 'none', boxShadow: T.elev2 }}>
          <ArrowLeft size={16} /> {user ? 'Back to your dashboard' : 'Back to OmniView'}
        </Link>
      </div>
    </main>
  );
}
